import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/logo_aragon_blanco.png'
import _imports_1 from '../../assets/img/logo_iam.webp'
import _imports_2 from '../../assets/img/logo_corresponsables.webp'


const _hoisted_1 = { class: "row container p-0 m-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-left" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col align-self-start m-5 p-0" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "logoMain-aragon",
        src: _imports_0,
        alt: "Gobierno de Aragón logo"
      })
    ])
  ])
], -1)
const _hoisted_3 = {
  class: "row p-0 m-0 pt-5 pb-3",
  style: {"background-color":"#f1fefa"}
}
const _hoisted_4 = { class: "col-12 col-md item1" }
const _hoisted_5 = { class: "fw-normal landingTitle flex-fill mt-3 mb-3" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-md p-0 m-0 me-2 item2\"><div class=\"row d-flex text-end mx-2\"><div class=\"col p-0 ml-auto text-end\"><img class=\"logoMain-iam\" src=\"" + _imports_1 + "\" alt=\"IAM logo\"></div><div class=\"col justify-self-end pe-2\"><img class=\"logoMain-corresponsables\" src=\"" + _imports_2 + "\" alt=\"Plan Corresponsables logo\"></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.i18n("planCorresponsables")), 1)
      ]),
      _hoisted_6
    ])
  ]))
}